import React from 'react';
import PropTypes from 'prop-types';

import { PieChart, Pie, Cell, Tooltip, Sector } from 'recharts';

import { nsColorConstants } from '../../../util/GlobalConstant';

import { nsColorFinder } from '../../../util';

import style from './index.scss';

class NestPieChart extends React.Component {
  static propTypes = {
    data: PropTypes.array,
    name: PropTypes.string
  };

  constructor(props) {
    super(props);

    this.state = {
      activePie: 0
    };
  }

  onPieEnter = (data, index) => {
    this.setState({
      activePie: index
    });
  };

  onPieLeave = (data, index) => {
    this.setState({
      activePie: 0
    });
  };

  render() {
    const { activePie } = this.state;
    const { data, name, colors, valueKey } = this.props;

    if (!data) {
      return null;
    }

    const dataKey = valueKey || 'value';

    const alerts = data?.totalAlerts;
    const hits = data?.totalHits;
    const colorPalette =
      colors && Array.isArray(colors) && colors.length >= 4 ? colors : null;

    const {
      falseHits,
      hitYield,
      level1,
      totalAlerts,
      totalHits,
      trueHits,
      undetermined
    } = data;

    const formattedData = [
      {
        id: 'falseHits',
        name: 'False Hits',
        value: falseHits?.count
      },
      {
        id: 'hitYield',
        name: 'Hit Yield',
        value: hitYield?.count
      },
      {
        id: 'trueHits',
        name: 'True Hits',
        value: trueHits?.count
      },
      // {
      //   "id": "level1",
      //   "name": "L1",
      //   "value": level1.count,
      // },
      {
        id: 'undetermined',
        name: 'Undetermined Hits',
        value: undetermined?.count
      }
    ];
    return (
      <div className={style.wrapper}>
        <PieChart width={250} height={190} style={{ margin: 'auto' }}>
          <Pie
            data={formattedData}
            dataKey={dataKey}
            nameKey="id"
            innerRadius={35}
            outerRadius={55}
            fill="#fff"
            paddingAngle={1}
            minAngle={1}
            activeIndex={activePie}
            activeShape={(props) => {
              return renderTrueHitShape(
                props,
                hits,
                colorPalette ? colorPalette[activePie] : null
              );
            }}
            onMouseEnter={this.onPieEnter}
            onMouseLeave={this.onPieLeave}>
            <Cell key="falseHits" fill={nsColorFinder('falseHits')} />
            <Cell key="hitYield" fill={nsColorFinder('hitYield')} />
            <Cell key="trueHits" fill={nsColorFinder('trueHits')} />
            {/* <Cell
            key="level1"
            fill={nsColorFinder('level1')} /> */}
            <Cell key="undetermined" fill={nsColorFinder('undetermined')} />
          </Pie>
        </PieChart>
        <div className={style.capton}>
          <h5>{name || ''}</h5>
          <p>Alerts - {alerts}</p>
        </div>
      </div>
    );
  }
}

export default NestPieChart;

const renderTrueHitShape = (props, hitsValue, color) => {
  const RADIAN = Math.PI / 180;
  const {
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    startAngle,
    endAngle,
    fill,
    payload,
    percent,
    value
  } = props;
  const sin = Math.sin(-RADIAN * midAngle);
  const cos = Math.cos(-RADIAN * midAngle);
  const sx = cx + (outerRadius + 10) * cos;
  const sy = cy + (outerRadius + 10) * sin;
  const mx = cx + (outerRadius + 20) * cos;
  const my = cy + (outerRadius + 20) * sin;
  const ex = mx + (cos >= 0 ? 1 : -1) * 20;
  const ey = my;
  const textAnchor = cos >= 0 ? 'start' : 'end';

  return (
    <g>
      <circle
        cx={cx}
        cy={cy}
        r={30}
        fill={nsColorConstants.hits}
        stroke="none"
      />
      <text x={cx} y={cy} dy={8} textAnchor="middle" fill={'white'}>
        {hitsValue}
      </text>
      <Sector
        cx={cx}
        cy={cy}
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        startAngle={startAngle}
        endAngle={endAngle}
        fill={color ? color : nsColorFinder(payload.id)}
      />
      <Sector
        cx={cx}
        cy={cy}
        startAngle={startAngle}
        endAngle={endAngle}
        innerRadius={outerRadius + 6}
        outerRadius={outerRadius + 10}
        fill={nsColorConstants.hitsYield}
      />
      <text
        x={ex + (cos >= 0 ? -25 : 10)}
        y={ey}
        textAnchor={textAnchor}
        fill="#333">{`${value}`}</text>
      <text
        x={ex + (cos >= 0 ? -27 : 10)}
        y={ey}
        dy={12}
        textAnchor={textAnchor}
        scaleToFit={true}
        fill="#999">
        {`(${(percent * 100).toFixed(0)}%)`}
      </text>
    </g>
  );
};

export class TwoSliceDonutChart extends React.Component {
  constructor(props) {
    super(props);
  }

  toggleExpand = () => {
    this.setState({
      expand: !this.state.expand
    });
  };

  render() {
    const { data, text, dataKey } = this.props;

    if (!data || !dataKey) {
      return null;
    }

    return (
      <PieChart width={300} height={260}>
        <g className="chart-text" id="text-on-center">
          <text x="45%" y="50%" className="chart-number">
            {`T+${text || ''}`}
          </text>
        </g>
        <g className="chart-text" id="text-on-left">
          <text x="15%" y="45%" className="chart-number">
            {`${data.length > 0 && data[0].value}`}
          </text>
        </g>
        <g className="chart-text" id="text-on-right">
          <text x="80%" y="65%" className="chart-number">
            {`${data.length > 0 && data[1].value}`}
          </text>
        </g>
        <Pie
          data={data}
          innerRadius={40}
          outerRadius={80}
          dataKey={dataKey}
          fill="#8884d8"
          paddingAngle={1}
          startAngle={90}
          endAngle={450}>
          {data.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={entry.id == 'A' ? '#6bbed7' : '#335777'}
            />
          ))}
        </Pie>
        <Tooltip />
      </PieChart>
    );
  }
}
